import React from 'react';
import { View, StyleSheet } from 'react-native';
import { withTheme } from '../../core/theming';

const ButtonGroup = _ref => {
  let {
    isVertical = true,
    style,
    children,
    theme,
    itemStyle: itemCustomStyle
  } = _ref;
  const containerStyle = [styles.container, {
    flexDirection: isVertical ? 'column' : 'row',
    backgroundColor: theme.colors.background.white
  }, style];
  const itemStyle = isVertical ? styles.itemVertical : styles.itemHorizontal;
  return /*#__PURE__*/React.createElement(View, {
    style: containerStyle
  }, React.Children.toArray(children).filter(x => /*#__PURE__*/React.isValidElement(x)).map((item, index) => {
    return /*#__PURE__*/React.createElement(View, {
      key: index,
      style: index === 0 ? !isVertical && {
        flex: 1
      } : [itemStyle, itemCustomStyle]
    }, item);
  }));
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 36,
    paddingVertical: 24
  },
  itemVertical: {
    marginTop: 24
  },
  itemHorizontal: {
    flex: 1,
    marginLeft: 16
  }
});
export default withTheme(ButtonGroup);
//# sourceMappingURL=ButtonGroup.js.map